import { ALL_SITE_CONNECTIONS_REPORT_MESSAGE_LINK } from "./constants";

export function AllSiteConnectionsInfoMessage() {
  return (
    <>
      All Sites Report is an internal report used to assist with estate level
      audits, repairer/repairer group reviews and high level subscription
      alignment tasks.
      <br />
      More information can be found within{' '}
      <a
        href={ALL_SITE_CONNECTIONS_REPORT_MESSAGE_LINK}
        target="_blank"
        rel="noreferrer"
      >
        Confluence
      </a>
    </>
  );
}